import React from "react";
import Courses from "../../Component/Courses.js";
import "../../Styling/NavCourses.css";
import Layout from "../../Component/Courses.js";

const CoursesNavBar = () => {
  return (
    <div className="courses">
      <Layout />
    </div>
  );
};

export default CoursesNavBar;
